
import React from 'react';
import logo from '../assets/images/Logo.png';
import styles from '../styles/RefundPolicy.module.css';

const RefundPolicy = () => (
  <div className={styles['refund-container']}>
    <div className={styles['refund-header-row']}>
      <div className="aboutus-logo-col">
        <img src={logo} alt="AstroShubh Logo" className={styles['refund-logo']} />
      </div>
      <div className={styles['refund-title-col']}>
        <h1 className={styles['refund-title']}>Refund & Cancellation Policy</h1>
        <p className={styles['refund-company-info']}>
          <span><strong>Website:</strong> www.astroshubh.com</span><br/>
          <span><strong>Operated by:</strong> Tara Infotech ("Company")</span><br/>
          <span><strong>Brand Name:</strong> AstroShubh</span>
        </p>
      </div>
    </div>
    <div className={styles['refund-content']}>
      <h2 className={styles['refund-main-title']}>Refund & Cancellation Policy</h2>
      <div className={styles['refund-section-text']}>
  <p>At AstroShubh (Tara Infotech), we strive to ensure customer satisfaction with our products and services. This Refund & Cancellation Policy outlines the conditions under which returns, refunds, or cancellations may be processed.</p>
  <br />
  <p>By purchasing from our Website (https://astroshubh.com), you agree to the terms mentioned below.</p>
  <br />
        <h3>1. GENERAL REFUND CONDITIONS</h3>
        <ul>
          <li>Refund requests must be initiated within 7 (seven) days of purchase (“Permissible Return Time”).</li>
          <li>Refunds will only be processed for eligible products/services and at the sole discretion of the Company.</li>
          <li>No refund shall be issued if incorrect or incomplete details (e.g., wrong birth details) are provided by the user.</li>
        </ul>
        <h3>2. NON-RETURNABLE / NON-REFUNDABLE ITEMS</h3>
  <p>Due to the nature of astrological and digital services, certain products are non-returnable and non-refundable:</p>
  <br />
        <ul>
          <li>Downloadable e-books, PDFs, reports, and digital remedies.</li>
          <li>Personalized astrology reports (e.g., Kundli Reports, Lal Kitab, Fortune Reports, Couple Matching, Dosha Analysis, etc.).</li>
          <li>Custom remedies or personalized consultations.</li>
          <li>Gift cards or prepaid vouchers.</li>
        </ul>
  <p>⚠️ Once delivered, personalized reports and digital products cannot be returned or refunded.</p>
  <br />
        <h3>3. ELIGIBLE RETURNS (IF APPLICABLE)</h3>
        <ul>
          <li>Wrong product delivered.</li>
          <li>Duplicate payment deducted due to technical error.</li>
          <li>Services not delivered despite payment.</li>
        </ul>
        <h3>4. REFUND PROCESS</h3>
        <ul>
          <li>To request a refund, email support@astroshubh.com with proof of purchase.</li>
          <li>Once your request is reviewed, we will notify you regarding approval or rejection.</li>
          <li>Approved refunds will be credited back to your original payment method within 7–10 working days, subject to banking timelines.</li>
        </ul>
        <h3>5. PARTIAL REFUNDS</h3>
        <ul>
          <li>Partial refunds may be considered if:</li>
          <ul>
            <li>A digital product is partially accessible due to a technical fault.</li>
            <li>Duplicate services are purchased accidentally.</li>
          </ul>
        </ul>
        <h3>6. LATE OR MISSING REFUNDS</h3>
        <ul>
          <li>If refund not received after approval, first check with your bank/payment provider.</li>
          <li>Processing delays may occur due to external banking procedures.</li>
          <li>If still not received, contact us at support@astroshubh.com.</li>
        </ul>
        <h3>7. SALE & DISCOUNTED ITEMS</h3>
  <p>All discounted or sale items are final sale and cannot be returned, exchanged, or refunded.</p>
  <br />
        <h3>8. EXCHANGES (IF APPLICABLE)</h3>
  <p>We replace items only if they are defective or wrongly delivered. Exchange eligibility will be assessed case by case.</p>
  <br />
        <h3>9. SHIPPING POLICY (IF PHYSICAL PRODUCTS ARE SOLD)</h3>
        <ul>
          <li>Free shipping within India on eligible physical items.</li>
          <li>International shipping charges apply as per courier rates.</li>
          <li>Customs, duties, or taxes (for international shipments) are the responsibility of the customer.</li>
          <li>Refunds for international orders will be processed only after items are received back, subject to deductions of customs and shipping charges.</li>
        </ul>
        <h3>10. ORDER CANCELLATION</h3>
        <ul>
          <li>Orders for digital services (reports, remedies, consultations) cannot be cancelled once processed.</li>
          <li>Orders for physical items may be cancelled before dispatch by emailing support.</li>
        </ul>
        <h3>11. REFUND METHOD</h3>
        <ul>
          <li>Refunds will only be issued to the original payment source (bank account, card, UPI, etc.).</li>
          <li>No refunds will be made to alternate accounts.</li>
        </ul>
        <h3>12. GOVERNING LAW & DISPUTE RESOLUTION</h3>
  <p>This Refund & Cancellation Policy is governed by the laws of India. Any disputes shall be subject to arbitration in Gurugram, Haryana, in accordance with the Arbitration and Conciliation Act, 1996.</p>
  <br />
        <h3>13. CONTACT US</h3>
  <p>For queries or refund requests, please contact:</p>
  <br />
  <p>📧 support@astroshubh.com</p>
  <br />
      </div>
    </div>
  </div>
);

export default RefundPolicy;
